// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AppSandboxRouteImport } from './routes/app.sandbox'
import { Route as AppChatsRouteImport } from './routes/app.chats'
import { Route as AppCConversationIdRouteImport } from './routes/app.c.$conversationId'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SigninRoute = SigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppSandboxRoute = AppSandboxRouteImport.update({
            id: '/sandbox',path: '/sandbox',getParentRoute: () => AppRoute
          })
const AppChatsRoute = AppChatsRouteImport.update({
            id: '/chats',path: '/chats',getParentRoute: () => AppRoute
          })
const AppCConversationIdRoute = AppCConversationIdRouteImport.update({
            id: '/c/$conversationId',path: '/c/$conversationId',getParentRoute: () => AppRoute
          })





const AppRouteChildren = {
  AppChatsRoute: AppChatsRoute,AppSandboxRoute: AppSandboxRoute,AppIndexRoute: AppIndexRoute,AppCConversationIdRoute: AppCConversationIdRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,PrivacyRoute: PrivacyRoute,SigninRoute: SigninRoute,TermsRoute: TermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)